import * as React from "react"
import {useSignal} from "@preact/signals-react";
import {Box, Chip} from "@mui/material";
import { AlertSeeker } from "@ui-seeker/core"

import {LabelCountry} from "@components";


export default function DynamicAssortmentSitesWarnings({warnings}) {

    const isOpen = useSignal(true)

    return <Box sx={{ width: 1, py: 1 }}>
        <AlertSeeker
            isOpen={isOpen.value}
            severity="warning"
            controller={() => isOpen.value = !isOpen.value}
            title="Sites Skus Scope Warnings"
            open={true}
        >
            The following sites dont have any skus for their assortment scope:
            { warnings.map((item, idx) => <Chip
                sx={{ ml: 1, mt: 1,  p: 0.5,  backgroundColor: 'disabled.light'}}
                key={idx}
                label={<LabelCountry country={item.country} label={item.retailer}/>}
            />) }
        </AlertSeeker>
    </Box>

}
